import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import ScrollToTop from "./components/ScrollToTop";
import TopNav from "./components/TopNav";
import LeftSidebar from "./components/LeftSidebar";
import RightContent from "./components/RightContent";
import SygnPdfPage from "./components/SygnPdfPage";
import BlogPage from "./components/BlogPage";
import MusicPage from "./components/MusicPage";
import MediaPage from "./components/MediaPage";
import PhotographyPage from "./components/PhotographyPage";
import VideographyPage from "./components/VideographyPage";
import RoadmapPage from "./components/RoadmapPage";
import UnifiedIdentityPost from "./components/UnifiedIdentityPost";
import MorselsPost from "./components/MorselsPost";
import NotFoundPage from "./components/NotFoundPage";
import BuildingInPublicPage from "./components/BuildingInPublicPage";

const HomePage = () => {
  return (
    <>
      <div className="main-container">
        <LeftSidebar />
        <RightContent />
      </div>
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: 'rgba(182, 180, 189, 0.2)',
              color: '#fff',
              border: 'none',
            },
          }}
        />
        <BrowserRouter>
          <ScrollToTop />
          <TopNav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/media/photography" element={<PhotographyPage />} />
            <Route path="/media/videography" element={<VideographyPage />} />
            <Route path="/roadmap" element={<RoadmapPage />} />
            <Route path="/unified-identity" element={<UnifiedIdentityPost />} />
            <Route path="/morsels" element={<MorselsPost />} />
            <Route path="/sygn" element={<SygnPdfPage />} />
            <Route path="/building-in-public" element={<BuildingInPublicPage />} />
            {/* 404 catch-all route - must be last */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
